// extracted by mini-css-extract-plugin
export default {"PrimaryTitleWrapper":"NotFound_PrimaryTitleWrapper__xuzjA","MainWrapper":"NotFound_MainWrapper__0D6ln","ListWrapper":"NotFound_ListWrapper__zQ4t0"};